export default __webpack_public_path__ + "static/media/trade_hk_09.7350c604.png";